import { useOrgContext } from 'app/orgProvider'
import { useNavigate, usePathname } from 'app/routx-router'
import logEvent from 'app/utils/analytics'

const PLAN_PRESENTATION_PAGE_PATH = 'view_plans_presentation'

const useLogAndNavToUpgradePlans = () => {
  const origin = usePathname()
  const nav = useNavigate()
  const org = useOrgContext()

  return () => {
    logEvent(PLAN_PRESENTATION_PAGE_PATH, { origin })
    nav(`/farms/${org.id}/admin/upgrade-to-premium`, {
      search: { step: 'choose_subscription', origin },
      origin
    })
  }
}

export default useLogAndNavToUpgradePlans
